<template>
    <div>
        <div class="filter-box" v-if="isTableMounted">
            <div class="d-flex mb-4 px-3 px-sm-4 flex-wrap align-items-center gap-3">
                <b-form-group class="text-left label font-weight-normal search-field mb-0 mr-0">
                    <b-input-group class="username-input-field">
                        <b-form-input type="text" :placeholder="$t('maintenanceShared.search')" v-model="filterFields.search" class="unit f-12"
                            @keyup.enter="getMaintenanceTotalData()"></b-form-input>
                        <b-input-group-append>
                            <b-button variant="primary" @click="getMaintenanceTotalData()">
                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M6.14286 11.7857C8.98318 11.7857 11.2857 9.48318 11.2857 6.64286C11.2857 3.80254 8.98318 1.5 6.14286 1.5C3.30254 1.5 1 3.80254 1 6.64286C1 9.48318 3.30254 11.7857 6.14286 11.7857Z"
                                        stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 10.5L13 13.5" stroke="white" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
                <b-form-group class="mb-0 report-fields">
                    <b-form-group class="text-left select_arrow label mb-0">
                        <b-form-select class="input f-12" :options="[
                            {
                                value: '',
                                text: $t('maintenanceTotals.all'),
                            }, ...getRemainingQuarters()
                        ]" v-model="filterFields.date" @change="getMaintenanceTotalData()"></b-form-select>
                    </b-form-group>
                </b-form-group>
                <div class="ml-auto d-none d-sm-flex flex-wrap align-items-center">
                    <div class="position-relative">
                        <div class="position-absolute notification-badge" v-if="activeFiltersCount">
                            {{ activeFiltersCount }}
                        </div>
                        <button class="btn btn-filter-section" @click="$bvModal.show('modal-filter')">
                            <div class="d-flex align-items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-sliders-horizontal w-4 h-4"
                                    data-id="element-964">
                                    <line x1="21" x2="14" y1="4" y2="4"></line>
                                    <line x1="10" x2="3" y1="4" y2="4"></line>
                                    <line x1="21" x2="12" y1="12" y2="12"></line>
                                    <line x1="8" x2="3" y1="12" y2="12"></line>
                                    <line x1="21" x2="16" y1="20" y2="20"></line>
                                    <line x1="12" x2="3" y1="20" y2="20"></line>
                                    <line x1="14" x2="14" y1="2" y2="6"></line>
                                    <line x1="8" x2="8" y1="10" y2="14"></line>
                                    <line x1="16" x2="16" y1="18" y2="22"></line>
                                </svg>
                                <p class="mb-0 ml-2">{{ $t('maintenanceShared.filters') }}</p>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!isTableMounted" class="mt-2" style="height: calc(100vh - 225px); overflow: hidden;">
            <b-skeleton-table :rows="17" :columns="7"
                :table-props="{ hover: true, responsive: true }"></b-skeleton-table>
        </div>
        <b-table v-else class="mt-2" responsive :fields="translatedFields" :items="items" hover :current-page="currentPage"
            :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true" :busy.sync="isBusy"
            :sticky-header="'calc(100vh - 330px)'" :show-empty="emptyTable">
            <template #cell(total_miles)="data">
                {{
                    data.value !== "-" ? `${getAmount(data.value)}` : "-"
                }}
            </template> <template #cell(cost_per_mile)="data">
                {{
                    data.value !== "-" ? `$${getAmount(data.value)}` : "-"
                }}
            </template>
            <template #cell(total_maintenance_amount)="data">
                {{
                    data.value !== "-" ? `$${getAmount(data.value)}` : "-"
                }}
            </template>
            <template #cell(cpm_change_percentage)="data">
                <span :style="{ color: data.value !== 0 ? data.value > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                    <i v-if="data.value !== 0" class="fa" :class="data.value > 0 ? 'fa-arrow-up' : 'fa-arrow-down'"
                        aria-hidden="true"></i>
                    {{
                        `${getFormattedValue(data.value)}%`
                    }}
                </span>
            </template>
            <template #cell(amount_change_percentage)="data">
                <span :style="{ color: data.value !== 0 ? data.value > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                    <i v-if="data.value !== 0" class="fa" :class="data.value > 0 ? 'fa-arrow-up' : 'fa-arrow-down'"
                        aria-hidden="true"></i>
                    {{
                        `${getFormattedValue(data.value)}%`
                    }}
                </span>
            </template>
            <template v-slot:custom-foot>
                <tr class="sticky-footer">
                    <td></td>
                    <td></td>
                    <th class="text-right f-14">{{ totalMiles ? `${getAmount(totalMiles)}` : "-" }}</th>
                    <th class="text-right f-14">{{ costPerMile ? `$${getAmount(costPerMile)}` : "-" }}</th>
                    <th class="text-right f-14">
                        <span
                            :style="{ color: cpmChangePercentage !== 0 ? cpmChangePercentage > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                            <i v-if="cpmChangePercentage !== 0" class="fa"
                                :class="cpmChangePercentage > 0 ? 'fa-arrow-up' : 'fa-arrow-down'" aria-hidden="true"></i>
                            {{
                                `${getFormattedValue(cpmChangePercentage)}%`
                            }}
                        </span>
                    </th>
                    <th class="text-right f-14">{{ totalAmount ? `$${getAmount(totalAmount)}` : "-" }}</th>
                    <th class="text-right f-14">
                        <span
                            :style="{ color: totalAmountPercentage !== 0 ? totalAmountPercentage > 0 ? '#FF0000' : '#2CCE89' : '#000000' }">
                            <i v-if="totalAmountPercentage !== 0" class="fa"
                                :class="totalAmountPercentage > 0 ? 'fa-arrow-up' : 'fa-arrow-down'" aria-hidden="true"></i>
                            {{
                                `${getFormattedValue(totalAmountPercentage)}%`
                            }}
                        </span>
                    </th>
                </tr>
            </template>
        </b-table>
        <div class="entries-pagination px-0 px-sm-2" v-if="isTableMounted">
            <div class="d-flex align-items-center flex-wrap">
                <div class="text-left show-entries mr-md-3 pl-3 pl-md-0 ml-md-0">
                    <b-form-select v-model="perPage" :options="pageOptions" />
                </div>
                <p class="my-0 pr-3 pr-md-0 mr-md-1 mt-0 f-14">{{ positionText }}</p>
                <div class="pagination">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
                        aria-controls="my-table"></b-pagination>
                </div>
            </div>
        </div>
        <b-modal id="modal-filter" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
            :body-class="'px-3 pt-3 pb-1'" no-close-on-esc>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('maintenanceShared.filters') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="body">
                <b-form-group :label="$t('maintenanceShared.type')" class="text-left select_arrow label mb-3">
                    <b-form-select v-model="filterFields.type" class="input f-12" :options="typeFilterOptions" @change="getMaintenanceTotalData()"></b-form-select>
                </b-form-group>
                <b-form-group :label="$t('maintenanceShared.tags')" class="text-left w-equipment-box mb-3">
                    <v-select multiple class="f-12 bg-grey" :options="allTags" :reduce="(option) => option.id"
                        v-model="filterFields.tags" @input="getMaintenanceTotalData()" />
                </b-form-group>

            </div>
            <template #modal-footer="">
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 justify-content-between mx-0">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0 btn-outline-primary" variant="primary"
                        @click="resetFilterFields(); $bvModal.hide('modal-filter')">{{ $t('maintenanceShared.reset') }}</b-button>
                    <b-button class="mx-0 h-40px w-100px m-0 m-0" block
                        @click="$bvModal.hide('modal-filter')">{{ $t('maintenanceShared.close') }}</b-button>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css"
import * as moment from "moment-timezone";

export default {
    name: "Totals",
    components: { vSelect },
    data() {
        return {
            filterFields: {
                search: '',
                type: '',
                date: '',
                tags: [],
                status: ''
            },
            momentFormat: {
                //[optional] Date to String
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                //[optional]  String to Date
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            items: [],
            rows: 0,
            totalAmount: 0,
            costPerMile: 0,
            totalMiles: 0,
            cpmChangePercentage: 0,
            totalAmountPercentage: 0,
            allTags: [],
            positionText: "",
            sortBy: undefined,
            sortDesc: undefined,
            isBusy: false,
            isTableMounted: false,
            perPage: 10,
            emptyTable: false,
            currentPage: 1,
            pageOptions: [
                {
                    value: 10,
                    text: "10",
                },
                {
                    value: 25,
                    text: "25",
                },
                {
                    value: 50,
                    text: "50",
                },
                {
                    value: 100,
                    text: "100",
                },
            ],
        }
    },
    methods: {
        ...mapActions(["getMaintenanceTotal", "getAllTags", "getMaintenanceTotalRecordsExportData", "setLoader", "setNotification"]),
        getFormattedValue(item) {
            return item ? parseFloat(item).toFixed(0) : 0;
        },
        getRemainingQuarters() {
            const result = [];
            const startYear = 2025;
            const startMonth = 0; // Jan
            const now = new Date();

            const currentYear = now.getFullYear();
            const currentMonth = now.getMonth();

            const monthNames = [
                "Jan", "Feb", "Mar",
                "Apr", "May", "Jun",
                "July", "Aug", "Sept",
                "Oct", "Nov", "Dec"
            ];

            const pad = (n) => String(n).padStart(2, "0");

            const lastDayOfMonth = (y, m) =>
                new Date(y, m + 1, 0).getDate();

            for (let year = currentYear; year >= startYear; year--) {

                // ---------- YEAR (always full year) ----------
                result.push({
                    text: `${year}`,
                    value: `start_date=${year}-01-01&end_date=${year}-12-31`,
                    type: "year"
                });

                for (let q = 4; q >= 1; q--) {
                    const qStart = (q - 1) * 3;
                    const qEnd = qStart + 2;

                    // ❌ Skip quarters that haven't started yet (current year only)
                    if (year === currentYear && qStart > currentMonth) continue;

                    // ❌ Skip quarters before Jan 2025
                    if (year === startYear && qEnd < startMonth) continue;

                    const qStartDate = `${year}-${pad(qStart + 1)}-01`;
                    const qEndDate = `${year}-${pad(qEnd + 1)}-${lastDayOfMonth(year, qEnd)}`;

                    // ---------- QUARTER ----------
                    result.push({
                        text: `${year} Q${q}`,
                        value: `start_date=${qStartDate}&end_date=${qEndDate}`,
                        type: "quarter"
                    });

                    // ---------- MONTHS ----------
                    for (let m = qEnd; m >= qStart; m--) {

                        // ❌ Future months (current year)
                        if (year === currentYear && m > currentMonth) continue;

                        // ❌ Before Jan 2025
                        if (year === startYear && m < startMonth) continue;

                        const mStart = `${year}-${pad(m + 1)}-01`;
                        const mEnd = `${year}-${pad(m + 1)}-${lastDayOfMonth(year, m)}`;

                        result.push({
                            text: `${year} ${monthNames[m]}`,
                            value: `start_date=${mStart}&end_date=${mEnd}`,
                            type: "month"
                        });
                    }
                }
            }

            return result;
        },


        getAmount(val) {
            return parseFloat(val).toLocaleString("en", {
                useGrouping: false,
                minimumFractionDigits: 2,
            });
        },
        async resetFilterFields() {
            this.filterFields = {
                search: '',
                type: '',
                date: '',
                tags: [],
                status: ''
            }
            await this.getMaintenanceTotalData()
        },
        async downloadExcel() {
            try {
                this.setLoader(true)
                let url = ""
                let tags = ""
                Object.keys(this.filterFields).map((key) => {
                    if (key === "tags" && this.filterFields[key].length > 0) {
                        this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
                        url += `${key}=${encodeURIComponent(tags)}&`
                    }
                    else if (key === 'date') {
                        url += `${this.filterFields[key]}&`
                    }
                    else if (this.filterFields[key] !== '' && key !== 'tags' && key !== 'date') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=unit_no&sort_order=asc&`
                }
                const data = await this.getMaintenanceTotalRecordsExportData(url)
                const blob = new Blob([data], { type: 'text/csv' });
                const csvUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.style.display = 'none';
                a.href = csvUrl;
                a.download = 'total-records.csv';
                a.target = "_blank"
                document.body.appendChild(a);
                a.click();
                a.remove()
                window.URL.revokeObjectURL(url);
                await this.setNotification({
                    msg: this.$t('maintenanceTotals.fileExported'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        async getMaintenanceTotalData() {
            try {
                this.isBusy = true
                let url = ""
                let tags = ""
                Object.keys(this.filterFields).map((key) => {
                    if (key === "tags" && this.filterFields[key].length > 0) {
                        this.filterFields[key].map((item, index) => index === 0 ? tags = item : tags += "," + item)
                        url += `${key}=${encodeURIComponent(tags)}&`
                    }
                    else if (key === 'date') {
                        url += `${this.filterFields[key]}&`
                    }
                    else if (this.filterFields[key] !== '' && key !== 'tags' && key !== 'date') {
                        url += `${key}=${this.filterFields[key]}&`
                    }
                })
                if (this.sortBy) {
                    url += `sort_field=${this.sortBy}&sort_order=${this.sortDesc ? "desc" : "asc"}&`
                }
                else {
                    url += `sort_field=unit_no&sort_order=asc&`
                }
                url += `page=${this.currentPage}&page_size=${this.perPage}`
                const data = await this.getMaintenanceTotal(url);
                if (data.total_entries) {
                    this.rows = data.total_entries
                    const start = this.currentPage === 1 ? 1 : (this.perPage * (this.currentPage - 1)) + 1
                    const end = this.perPage * (this.currentPage - 1) + data.queryset_count
                    this.positionText = this.$t('maintenanceShared.positionText', { start, end, total: data.total_entries })
                }
                else {
                    this.rows = 0
                    this.positionText = this.$t('maintenanceShared.emptyPosition')
                }
                this.totalAmount = data.total_amount
                this.costPerMile = data.cost_per_mile
                this.totalMiles = data.total_miles
                this.cpmChangePercentage = data.cost_per_mile_change_percentage != null ? Number(data.cost_per_mile_change_percentage) : 0
                this.totalAmountPercentage = data.total_amount_change_percentage != null ? Number(data.total_amount_change_percentage) : 0
                this.items = [];
                data.records.forEach(async (m, id) => {
                    this.items.push({
                        id: id,
                        pk: m.id,
                        unit_no: m.unit_no,
                        total_miles: m.total_miles,
                        cost_per_mile: m.cost_per_mile ? m.cost_per_mile : "0.00",
                        type: m.type,
                        total_maintenance_amount: m.total_maintenance_amount,
                        amount_change_percentage: m.amount_change_percentage != null ? Number(m.amount_change_percentage) : 0,
                        cpm_change_percentage: m.cpm_change_percentage != null ? Number(m.cpm_change_percentage) : 0,
                    });
                });
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
                this.isBusy = false
                this.isTableMounted = true
            }
            catch (e) {
                this.isBusy = false
                this.isTableMounted = true
                console.log(e)
            }
        },
    },
    computed: {
        ...mapGetters(['tags', 'company', 'userCompany']),
        translatedFields() {
            const baseTh = 'font-table-weight-bold text-right';
            return [
                { key: "unit_no", label: this.$t('maintenanceTotals.columnUnit'), sortable: true, visible: true, disabled: true, field: "text", stickyColumn: true, thClass: baseTh, tdClass: 'text-right' },
                { key: "type", label: this.$t('maintenanceTotals.columnType'), sortable: true, visible: true, disabled: true, field: "text", thClass: baseTh, tdClass: 'text-right' },
                { key: "total_miles", label: this.$t('maintenanceTotals.columnTotalMiles'), sortable: true, visible: true, disabled: true, field: "text", thClass: baseTh, tdClass: 'text-right' },
                { key: "cost_per_mile", label: this.$t('maintenanceTotals.columnCpm'), sortable: true, visible: true, disabled: true, field: "text", thClass: baseTh, tdClass: 'text-right' },
                { key: "cpm_change_percentage", label: this.$t('maintenanceTotals.columnCpmChange'), sortable: true, visible: true, disabled: true, field: "text", thClass: baseTh, tdClass: 'text-right' },
                { key: "total_maintenance_amount", label: this.$t('maintenanceTotals.columnTotal'), sortable: true, visible: true, disabled: false, field: "text", thClass: baseTh, tdClass: 'text-right' },
                { key: "amount_change_percentage", label: this.$t('maintenanceTotals.columnTotalChange'), sortable: true, visible: true, disabled: true, field: "text", thClass: baseTh, tdClass: 'text-right' },
            ];
        },
        typeFilterOptions() {
            return [
                { value: '', text: '' },
                { value: 'Vehicle', text: this.$t('maintenanceShared.vehicle') },
                { value: 'Trailer', text: this.$t('maintenanceShared.trailer') },
            ];
        },
        activeFiltersCount() {
            return Object.keys(this.filterFields).reduce((count, key) => {
                if (key === 'tags') {
                    return count + (this.filterFields.tags.length > 0 ? 1 : 0);
                } else if (
                    this.filterFields[key] !== '' &&
                    this.filterFields[key] !== null
                ) {
                    return count + 1;
                }
                return count;
            }, 0);
        },
    },
    watch: {
        perPage: {
            async handler() {
                await this.getMaintenanceTotalData();
            },
            immediate: true,
        },
        currentPage: {
            async handler() {
                await this.getMaintenanceTotalData();
            },
        },
        sortBy: {
            async handler() {
                await this.getMaintenanceTotalData();
            },
        },
        sortDesc: {
            async handler() {
                await this.getMaintenanceTotalData();
            },
        },
        filterFields: {
            handler() {
                this.currentPage = 1
            },
            deep: true
        },
        company: {
            async handler() {
                await this.getAllTags(this.userCompany);
                this.tags.map((item) => {
                    this.allTags.push({
                        id: item.add_tag,
                        label: item.add_tag,
                    });
                });
            },
            deep: true,
            immediate: true
        }
    }
}
</script>